import api from '@/api/index.js'

const distributor_client_ui = {
  state: {
    loading: false,
    auth: ""
  },

  mutations: {
    SET_DISTRIBUTOR_CLIENT_UI_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_DISTRIBUTOR_CLIENT_UI: (state, response) => {
      state.loading = false;
      state.auth = response.auth;
    },
  },

  actions: {
    GetDistributorClientUi({commit}, id) {
      commit('SET_DISTRIBUTOR_CLIENT_UI_LOADING', true)
      commit('SET_ERROR', null)
      return api.get(`distributor-client-ui/auth`)
        .then((response) => {
          commit('SET_DISTRIBUTOR_CLIENT_UI', response)
        })
        .catch((error) => {
          commit('SET_DISTRIBUTOR_CLIENT_UI_LOADING', false)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default distributor_client_ui
